/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cancelAppointment} from '../api'

export const useMutationCancelAppointment = createReactQueryMutationHook('cancelAppointment', cancelAppointment)
